import { useEffect } from "react";

export default function Vision() {

  useEffect(() => {
    const counters = document.querySelectorAll(".stat-number");

    const animateCount = (el) => {
      const target = +el.getAttribute("data-count");
      let current = 0;
      const duration = 2000;
      const stepTime = 20;
      const increment = Math.ceil(target / (duration / stepTime));

      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          current = target;
          clearInterval(timer);
        }
        el.textContent = current + (el.textContent.includes("%") ? "%" : el.textContent.includes("+") ? "+" : "");
      }, stepTime);
    };

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    counters.forEach((counter) => observer.observe(counter));
  }, []);

  return (
    <section className="vision">
      <div className="container vision-container">

        <div className="vision-quote">
          "Quality is not an act, it is a habit." - Phil Crosby
        </div>

        <div className="vision-stats">
          <div className="stat-item">
            <div className="stat-number" data-count="15">0+</div>
            <div className="stat-label">Years of Experience</div>
          </div>

          <div className="stat-item">
            <div className="stat-number" data-count="50">0+</div>
            <div className="stat-label">Natural Ingredients</div>
          </div>

          <div className="stat-item">
            <div className="stat-number" data-count="100">0%</div>
            <div className="stat-label">Transparency</div>
          </div>

          <div className="stat-item">
            <div className="stat-number" data-count="21">0</div>
            <div className="stat-label">Products</div>
          </div>
        </div>

      </div>
    </section>
  );
}
